// TODO: create common component for Plan types sections and use it in PlanSection component. Remove this component completely or remove duplicated code
import React, { FC } from 'react'

import { getPlansSlugs, planCollectionNames } from '@smarty-nx/contentful'
import { Plan } from '@smarty-nx/data'
import { Typography } from '@smarty-nx/ds'

import {
  PlanDataOnlyContent,
  PlanDataOnlyContentPhase2,
} from './data-only-sim-plans.content'
import classes from './data-only-sim-plans.module.scss'
import { PAGE_CONSTANTS } from '../../constants/globalStrings'
import CheckImage from '../../static/images/checkmark.svg'
import { matchPlanMeta } from '../../utils/plans'
import { PlanData } from '../../utils/plans.types'
import CoverageChecker from '../CoverageChecker'
import { TooltipModal } from '../Modals'
import { PlanCardSmall } from '../PlanCardSmall/PlanCardSmall'
import {
  CheckIcon,
  HideOnTablet,
  HideSmallDesktopUpwards,
  ListItem,
} from '../shared'
import spacerClasses from '../styles/spacer.module.scss'

const DATA_ONLY_PLANS = getPlansSlugs(planCollectionNames.DATA_ONLY_PLANS)

const renderToolTip = () => {
  const tooltipCopy = PlanDataOnlyContentPhase2

  return (
    <TooltipModal header={tooltipCopy.heading}>
      <Typography
        variant="Kollektif/ExtraSmall"
        className={classes.toolTipHeading}
      >
        {tooltipCopy.toolTipSubHeading}
      </Typography>
      <ul className={classes.list}>
        {tooltipCopy.dataSimTooltipList.map((item, index) => (
          <ListItem key={index}>
            <CheckIcon src={CheckImage} alt="" />
            <Typography
              variant="Kollektif/ExtraSmall"
              className={classes.itemList}
            >
              {item}
            </Typography>
          </ListItem>
        ))}
      </ul>
      <Typography variant="Kollektif/Small" className={classes.note}>
        {tooltipCopy.note}
        {tooltipCopy.noteText}
      </Typography>
    </TooltipModal>
  )
}

interface DataOnlySimPlansProps {
  plans?: Plan[]
  currentPlan?: { slug: string }
  hideProductAttributes?: boolean
  hideCoverageChecker?: boolean
  isDataSim?: boolean
}

export const DataOnlySimPlans: FC<DataOnlySimPlansProps> = ({
  currentPlan,
  plans,
  hideProductAttributes = false,
  hideCoverageChecker = false,
  isDataSim = false,
}) => (
  <section id="data-discount-plans" className={spacerClasses.spacerBottom}>
    <div className={classes.headingWithCoverage}>
      <div className={classes.headingsWrapper}>
        <div className={classes.mainHeadingWrapper}>
          <Typography
            component="h2"
            variant="Kollektif/Large"
            className={classes.headingSecondary}
            dataTestId="data-plans-heading"
          >
            {PlanDataOnlyContent.heading}
          </Typography>
          {renderToolTip()}
        </div>

        <Typography
          component="h2"
          variant="Kollektif/MediumEmphasis"
          className={classes.headingSecondarySmall}
          dataTestId="data-only-plans-small-heading"
        >
          {PlanDataOnlyContent.subHeading}
        </Typography>
      </div>

      {!hideCoverageChecker && (
        <HideOnTablet>
          <CoverageChecker />
        </HideOnTablet>
      )}
    </div>
    <div className={classes.plansWrapper}>
      {DATA_ONLY_PLANS.map((p, index) => {
        const result = matchPlanMeta(plans as Plan[], p)
        if (!result) {
          return null
        }
        const isCurrentPlan = currentPlan && p === currentPlan.slug
        const { priceData, planMeta } = result
        return (
          <PlanCardSmall
            key={p}
            index={index}
            parentElModule="plan-modules-data-sim"
            to={isCurrentPlan ? undefined : `/plans/${p}`}
            href={
              isCurrentPlan
                ? `${PAGE_CONSTANTS.GROUPS_ADD_SIM.route}/${p}`
                : undefined
            }
            planMeta={planMeta}
            priceData={priceData as unknown as PlanData}
            position={index + 1}
            cta={isCurrentPlan ? 'Get' : 'View'}
            hideProductAttributes={hideProductAttributes}
            isPlanDataOnly
            isDataSim={isDataSim}
          />
        )
      })}
    </div>
    {!hideCoverageChecker && (
      <div className={classes.topCoverageWrapper}>
        <HideSmallDesktopUpwards>
          <CoverageChecker />
        </HideSmallDesktopUpwards>
      </div>
    )}
  </section>
)

export default DataOnlySimPlans
